import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTypography',
  setup(__props) {

const headingsSeaction = defineAsyncComponent(() => import("@/components/theme/uikits/typography/headingsSeaction.vue"))
const coloredHeadings = defineAsyncComponent(() => import("@/components/theme/uikits/typography/coloredHeadings.vue"))
const fontWeight = defineAsyncComponent(() => import("@/components/theme/uikits/typography/fontWeight.vue"))
const listingTypography = defineAsyncComponent(() => import("@/components/theme/uikits/typography/listingTypography.vue"))
const displayHeadings = defineAsyncComponent(() => import("@/components/theme/uikits/typography/displayHeadings.vue"))
const textElements = defineAsyncComponent(() => import("@/components/theme/uikits/typography/textElements.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Typography"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(headingsSeaction)),
        _createVNode(_unref(coloredHeadings)),
        _createVNode(_unref(fontWeight)),
        _createVNode(_unref(listingTypography)),
        _createVNode(_unref(displayHeadings)),
        _createVNode(_unref(textElements))
      ])
    ])
  ], 64))
}
}

})